<div class="toggle-switch-container">
    @if (label) {
        <label class="toggle-label">{{ label }}</label>
    }
    <p-toggleswitch
        [ngModel]="checked"
        (ngModelChange)="onToggleChange($event)"
        [disabled]="disabled"
        [ngClass]="size"
        class="custom-toggle"
    />
</div>